<div class="add-note-form-container flex flex-row">
  <!-- Visibility Toggle (optional, for requirements only) -->
  <button *ngIf="showVisibilityToggle" 
    mat-icon-button 
    [ngClass]="visibilityIconButtonClass"
    [matTooltip]="noteForm?.get('isInternalNote')?.value ? 'Hidden on case document' : 'Visible on case document'"
    (click)="onVisibilityToggle()"
    [disabled]="disabled"
    type="button">
    <mat-icon>
      <ng-container *ngIf="!noteForm?.get('isInternalNote')?.value">visibility</ng-container>
      <ng-container *ngIf="noteForm?.get('isInternalNote')?.value">visibility_off</ng-container>
    </mat-icon>
  </button>

  <!-- Rich Text Editor -->
  <div class="text-area-container textarea-formfield">
    <app-rich-text-editor 
      *ngIf="noteForm"  
      class="configuration-editor workbench-note-editor"
      [formControl]="noteForm.get('note')"
      [placeholder]="placeholder"
      [disabled]="disabled">
    </app-rich-text-editor>

    <app-rich-text-editor 
      #templateDrivenEditor
      class="configuration-editor workbench-note-editor"
      *ngIf="!noteForm" 
      [ngModel]="newMessage"
      (ngModelChange)="newMessage = $event"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (onContentChanged)="onMessageChange($event.html)">
    </app-rich-text-editor>
  </div>

  <!-- Action Buttons -->
  <div class="action-button-container">
    <button mat-flat-button 
      style="background-color: transparent" 
      (click)="onClear()"
      [disabled]="disabled"
      type="button">
      Clear
    </button>
    <button mat-stroked-button 
      color="primary" 
      (click)="onSave()"
      [disabled]="disabled || ((!noteForm && newMessage === '') || (noteForm && noteForm.get('note').value === ''))"
      type="button">
      Save
    </button>
  </div>
</div>
